import {
  get_serializableAnnotations9pir9fao2oo as get_serializableAnnotations,
  ArrayValue2pyfxqxwawdsa as ArrayValue,
  StringValue3u4w9lwhg0ah4 as StringValue,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FormLayoutPreferences_ScreenBound_getInstanceoel3z407rvau as FormLayoutPreferences_ScreenBound_getInstance,
  Companion_getInstance17fcxlkqs50ig as Companion_getInstance,
  FormLayoutPreferences_Block_getInstance2bsp7v6nfhpj1 as FormLayoutPreferences_Block_getInstance,
} from './helpers.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { ErrorSemantic_getInstanceqmizdq1y2zzq as ErrorSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_displayNamehv5zo902rjy4 as get_displayName,
  get_importance1n558cdfj7ar as get_importance,
} from './annotationReaders.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { coerceAtLeastklytehohcpeq as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  take3onnpy6q7ctcz as take,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  get_UrlProperties24r163uv67g3 as get_UrlProperties,
  decodeFromString1e1s881w515pe as decodeFromString,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import {
  Companion_instance1kjus4hvx4qjx as Companion_instance,
  DataClassPath3joljqmfaqhxf as DataClassPath,
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { sortedWith13ny3qsmk2kn8 as sortedWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function form(_this__u8e3s4, context, serializer, mutable, annotations, desiredSize, field) {
  annotations = annotations === VOID ? get_serializableAnnotations(serializer) : annotations;
  desiredSize = desiredSize === VOID ? FormLayoutPreferences_ScreenBound_getInstance() : desiredSize;
  field = field === VOID ? null : field;
  var sel = new (FormSelector())(serializer, annotations, desiredSize);
  return context.ydt(sel).tds()(_this__u8e3s4, field, mutable);
}
var FormTypeInfoClass;
function FormTypeInfo() {
  if (FormTypeInfoClass === VOID) {
    class $ {}
    initMetadataForClass($, 'FormTypeInfo');
    FormTypeInfoClass = $;
  }
  return FormTypeInfoClass;
}
var GeneratorClass;
function Generator() {
  if (GeneratorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Generator', VOID, VOID, [RendererGenerator()]);
    GeneratorClass = $;
  }
  return GeneratorClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      jdx(module_0, generator, selector, size, handlesField, render) {
        return new (Standard())(module_0, generator, selector, size, handlesField, render);
      }
      mdu(module_0, generator, selector, size, handlesField, render, $super) {
        size = size === VOID ? ensureNotNull(generator).idu(module_0, selector) : size;
        handlesField = handlesField === VOID ? ensureNotNull(generator).uds() : handlesField;
        return $super === VOID ? this.jdx(module_0, generator, selector, size, handlesField, render) : $super.jdx.call(this, module_0, generator, selector, size, handlesField, render);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var StandardClass;
function Standard() {
  if (StandardClass === VOID) {
    class $ {
      constructor(module_0, generator, selector, size, handlesField, render) {
        size = size === VOID ? ensureNotNull(generator).idu(module_0, selector) : size;
        handlesField = handlesField === VOID ? ensureNotNull(generator).uds() : handlesField;
        this.mdx_1 = module_0;
        this.ndx_1 = generator;
        this.odx_1 = selector;
        this.pdx_1 = size;
        this.qdx_1 = handlesField;
        this.rdx_1 = render;
      }
      hdx() {
        return this.ndx_1;
      }
      sdx() {
        return this.odx_1;
      }
      p1() {
        return this.pdx_1;
      }
      uds() {
        return this.qdx_1;
      }
      tds() {
        return this.rdx_1;
      }
      toString() {
        return 'Standard(module=' + toString(this.mdx_1) + ', generator=' + toString_0(this.ndx_1) + ', selector=' + this.odx_1.toString() + ', size=' + this.pdx_1.toString() + ', handlesField=' + this.qdx_1 + ', render=' + toString(this.rdx_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.mdx_1);
        result = imul(result, 31) + (this.ndx_1 == null ? 0 : hashCode(this.ndx_1)) | 0;
        result = imul(result, 31) + this.odx_1.hashCode() | 0;
        result = imul(result, 31) + this.pdx_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.qdx_1) | 0;
        result = imul(result, 31) + hashCode(this.rdx_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Standard()))
          return false;
        if (!equals(this.mdx_1, other.mdx_1))
          return false;
        if (!equals(this.ndx_1, other.ndx_1))
          return false;
        if (!this.odx_1.equals(other.odx_1))
          return false;
        if (!this.pdx_1.equals(other.pdx_1))
          return false;
        if (!(this.qdx_1 === other.qdx_1))
          return false;
        if (!equals(this.rdx_1, other.rdx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Standard', VOID, VOID, [FormRenderer()]);
    StandardClass = $;
  }
  return StandardClass;
}
var BlankClass;
function Blank() {
  if (BlankClass === VOID) {
    class $ {
      constructor(module_0, selector) {
        this.tdx_1 = module_0;
        this.udx_1 = selector;
        this.vdx_1 = null;
        this.wdx_1 = false;
        this.xdx_1 = Companion_getInstance().kdu_1;
        var tmp = this;
        tmp.ydx_1 = (_this__u8e3s4, _unused_var__etf5q3, _unused_var__etf5q3_0) => {
          var tmp = _this__u8e3s4.hbb(ErrorSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          view.jbb(get_centered(view), text(view, 'Blank for ' + get_displayName(this.udx_1.edu_1)));
          _this__u8e3s4.fbb(p, view);
          return _this__u8e3s4.jbb(tmp, view);
        };
      }
      sdx() {
        return this.udx_1;
      }
      hdx() {
        return this.vdx_1;
      }
      uds() {
        return this.wdx_1;
      }
      p1() {
        return this.xdx_1;
      }
      tds() {
        return this.ydx_1;
      }
      toString() {
        return 'Blank(module=' + toString(this.tdx_1) + ', selector=' + this.udx_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.tdx_1);
        result = imul(result, 31) + this.udx_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Blank()))
          return false;
        if (!equals(this.tdx_1, other.tdx_1))
          return false;
        if (!this.udx_1.equals(other.udx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Blank', VOID, VOID, [FormRenderer()]);
    BlankClass = $;
  }
  return BlankClass;
}
var PlaceholderClass;
function Placeholder() {
  if (PlaceholderClass === VOID) {
    class $ {
      static zdx(module_0, start) {
        var $this = createThis(this);
        $this.vdw_1 = module_0;
        $this.wdw_1 = false;
        $this.xdw_1 = false;
        $this.ydw_1 = start;
        return $this;
      }
      static zdw(module_0, selector) {
        return this.zdx(module_0, new (Blank())(module_0, selector));
      }
      adx(value) {
        this.xdw_1 = true;
        this.ydw_1 = value;
      }
      hdx() {
        return this.ydw_1.hdx();
      }
      uds() {
        return this.ydw_1.uds();
      }
      sdx() {
        return this.ydw_1.sdx();
      }
      p1() {
        return this.ydw_1.p1();
      }
      tds() {
        return this.ydw_1.tds();
      }
    }
    initMetadataForClass($, 'Placeholder', VOID, VOID, [FormRenderer()]);
    PlaceholderClass = $;
  }
  return PlaceholderClass;
}
var FormRendererClass;
function FormRenderer() {
  if (FormRendererClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FormRenderer');
    FormRendererClass = $;
  }
  return FormRendererClass;
}
var FormSelectorClass;
function FormSelector() {
  if (FormSelectorClass === VOID) {
    class $ {
      constructor(serializer, annotations, desiredSize, handlesField) {
        desiredSize = desiredSize === VOID ? FormLayoutPreferences_Block_getInstance() : desiredSize;
        handlesField = handlesField === VOID ? false : handlesField;
        this.edu_1 = serializer;
        this.fdu_1 = annotations;
        this.gdu_1 = desiredSize;
        this.hdu_1 = handlesField;
      }
      toString() {
        return this.edu_1.az().h10();
      }
      ady(serializer, annotations, desiredSize, handlesField) {
        return new (FormSelector())(serializer, annotations, desiredSize, handlesField);
      }
      copyChangingType(serializer, annotations, desiredSize, handlesField, $super) {
        annotations = annotations === VOID ? this.fdu_1 : annotations;
        desiredSize = desiredSize === VOID ? this.gdu_1 : desiredSize;
        handlesField = handlesField === VOID ? this.hdu_1 : handlesField;
        return $super === VOID ? this.ady(serializer, annotations, desiredSize, handlesField) : $super.ady.call(this, serializer, annotations, desiredSize, handlesField);
      }
      hashCode() {
        var result = hashCode(this.edu_1);
        result = imul(result, 31) + hashCode(this.fdu_1) | 0;
        result = imul(result, 31) + this.gdu_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.hdu_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FormSelector()))
          return false;
        if (!equals(this.edu_1, other.edu_1))
          return false;
        if (!equals(this.fdu_1, other.fdu_1))
          return false;
        if (!this.gdu_1.equals(other.gdu_1))
          return false;
        if (!(this.hdu_1 === other.hdu_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FormSelector');
    FormSelectorClass = $;
  }
  return FormSelectorClass;
}
var GeneratorClass_0;
function Generator_0() {
  if (GeneratorClass_0 === VOID) {
    class $ {}
    initMetadataForInterface($, 'Generator', VOID, VOID, [RendererGenerator()]);
    GeneratorClass_0 = $;
  }
  return GeneratorClass_0;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      idx(module_0, generator, selector, size, handlesField, render) {
        return new (Standard_0())(module_0, generator, selector, size, handlesField, render);
      }
      odu(module_0, generator, selector, size, handlesField, render, $super) {
        size = size === VOID ? ensureNotNull(generator).idu(module_0, selector) : size;
        handlesField = handlesField === VOID ? ensureNotNull(generator).uds() : handlesField;
        return $super === VOID ? this.idx(module_0, generator, selector, size, handlesField, render) : $super.idx.call(this, module_0, generator, selector, size, handlesField, render);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var StandardClass_0;
function Standard_0() {
  if (StandardClass_0 === VOID) {
    class $ {
      constructor(module_0, generator, selector, size, handlesField, render) {
        size = size === VOID ? ensureNotNull(generator).idu(module_0, selector) : size;
        handlesField = handlesField === VOID ? ensureNotNull(generator).uds() : handlesField;
        this.bdy_1 = module_0;
        this.cdy_1 = generator;
        this.ddy_1 = selector;
        this.edy_1 = size;
        this.fdy_1 = handlesField;
        this.gdy_1 = render;
      }
      hdx() {
        return this.cdy_1;
      }
      sdx() {
        return this.ddy_1;
      }
      p1() {
        return this.edy_1;
      }
      uds() {
        return this.fdy_1;
      }
      tds() {
        return this.gdy_1;
      }
      toString() {
        return 'Standard(module=' + toString(this.bdy_1) + ', generator=' + toString_0(this.cdy_1) + ', selector=' + this.ddy_1.toString() + ', size=' + this.edy_1.toString() + ', handlesField=' + this.fdy_1 + ', render=' + toString(this.gdy_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.bdy_1);
        result = imul(result, 31) + (this.cdy_1 == null ? 0 : hashCode(this.cdy_1)) | 0;
        result = imul(result, 31) + this.ddy_1.hashCode() | 0;
        result = imul(result, 31) + this.edy_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.fdy_1) | 0;
        result = imul(result, 31) + hashCode(this.gdy_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Standard_0()))
          return false;
        if (!equals(this.bdy_1, other.bdy_1))
          return false;
        if (!equals(this.cdy_1, other.cdy_1))
          return false;
        if (!this.ddy_1.equals(other.ddy_1))
          return false;
        if (!this.edy_1.equals(other.edy_1))
          return false;
        if (!(this.fdy_1 === other.fdy_1))
          return false;
        if (!equals(this.gdy_1, other.gdy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Standard', VOID, VOID, [ViewRenderer()]);
    StandardClass_0 = $;
  }
  return StandardClass_0;
}
var BlankClass_0;
function Blank_0() {
  if (BlankClass_0 === VOID) {
    class $ {
      constructor(module_0, selector) {
        this.hdy_1 = module_0;
        this.idy_1 = selector;
        this.jdy_1 = null;
        this.kdy_1 = false;
        this.ldy_1 = Companion_getInstance().kdu_1;
        var tmp = this;
        tmp.mdy_1 = (_this__u8e3s4, _unused_var__etf5q3, _unused_var__etf5q3_0) => {
          var tmp = _this__u8e3s4.hbb(ErrorSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          view.jbb(get_centered(view), text(view, 'Blank for ' + get_displayName(this.idy_1.edu_1)));
          _this__u8e3s4.fbb(p, view);
          return _this__u8e3s4.jbb(tmp, view);
        };
      }
      sdx() {
        return this.idy_1;
      }
      hdx() {
        return this.jdy_1;
      }
      uds() {
        return this.kdy_1;
      }
      p1() {
        return this.ldy_1;
      }
      tds() {
        return this.mdy_1;
      }
      toString() {
        return 'Blank(module=' + toString(this.hdy_1) + ', selector=' + this.idy_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.hdy_1);
        result = imul(result, 31) + this.idy_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Blank_0()))
          return false;
        if (!equals(this.hdy_1, other.hdy_1))
          return false;
        if (!this.idy_1.equals(other.idy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Blank', VOID, VOID, [ViewRenderer()]);
    BlankClass_0 = $;
  }
  return BlankClass_0;
}
var PlaceholderClass_0;
function Placeholder_0() {
  if (PlaceholderClass_0 === VOID) {
    class $ {
      static ndy(module_0, start) {
        var $this = createThis(this);
        $this.pdw_1 = module_0;
        $this.qdw_1 = false;
        $this.rdw_1 = false;
        $this.sdw_1 = start;
        return $this;
      }
      static tdw(module_0, selector) {
        return this.ndy(module_0, new (Blank_0())(module_0, selector));
      }
      udw(value) {
        this.rdw_1 = true;
        this.sdw_1 = value;
      }
      hdx() {
        return this.sdw_1.hdx();
      }
      uds() {
        return this.sdw_1.uds();
      }
      sdx() {
        return this.sdw_1.sdx();
      }
      p1() {
        return this.sdw_1.p1();
      }
      tds() {
        return this.sdw_1.tds();
      }
    }
    initMetadataForClass($, 'Placeholder', VOID, VOID, [ViewRenderer()]);
    PlaceholderClass_0 = $;
  }
  return PlaceholderClass_0;
}
var ViewRendererClass;
function ViewRenderer() {
  if (ViewRendererClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ViewRenderer');
    ViewRendererClass = $;
  }
  return ViewRendererClass;
}
function get_kind() {
  return null;
}
function get_type() {
  return null;
}
function get_nullable() {
  return false;
}
function get_annotation() {
  return null;
}
function get_handlesField() {
  return false;
}
function size(module_0, selector) {
  return Companion_getInstance().jdu_1;
}
function get_basePriority() {
  return 1.0;
}
function priority(module_0, selector) {
  var amount = this.cdu();
  if (this.uds() && selector.hdu_1)
    amount = amount * 1.2;
  // Inline function 'kotlin.let' call
  var size = this.idu(module_0, selector);
  var tmp0_elvis_lhs = selector.gdu_1.qdy_1;
  var tmp = size.fds_1 - (tmp0_elvis_lhs == null ? 1000.0 : tmp0_elvis_lhs);
  var tmp1_elvis_lhs = selector.gdu_1.qdy_1;
  var widthOverage = coerceAtLeast(tmp / (tmp1_elvis_lhs == null ? 1000.0 : tmp1_elvis_lhs), 0.0);
  var tmp2_elvis_lhs = selector.gdu_1.rdy_1;
  var tmp_0 = size.gds_1 - (tmp2_elvis_lhs == null ? 1000.0 : tmp2_elvis_lhs);
  var tmp3_elvis_lhs = selector.gdu_1.rdy_1;
  var heightOverage = coerceAtLeast(tmp_0 / (tmp3_elvis_lhs == null ? 1000.0 : tmp3_elvis_lhs), 0.0);
  amount = amount * (1 / (1.0 + widthOverage));
  amount = amount * (1 / (1.0 + heightOverage));
  return amount;
}
function matches(module_0, selector) {
  if (!(this.pdu() === selector.edu_1.az().l11()))
    return false;
  if (!(this.f94() == null) && !(substringBefore(selector.edu_1.az().h10(), _Char___init__impl__6a9atx(47)) === this.f94()))
    return false;
  if (!(this.s11() == null) && !equals(selector.edu_1.az().s11(), this.s11()))
    return false;
  var tmp;
  if (!(this.qdu() == null)) {
    var tmp0 = selector.fdu_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.l4s_1 === this.qdu()) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  if (tmp)
    return false;
  return true;
}
var RendererGeneratorClass;
function RendererGenerator() {
  if (RendererGeneratorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RendererGenerator');
    RendererGeneratorClass = $;
  }
  return RendererGeneratorClass;
}
function defaultColumns(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_serializableAnnotations(_this__u8e3s4);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.l4s_1 === 'com.lightningkite.lightningdb.AdminTableColumns') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d2();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0 = tmp3_safe_receiver.f2();
    tmp = tmp_0 instanceof ArrayValue() ? tmp_0 : null;
  }
  var tmp4_safe_receiver = tmp;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.h4w_1;
  var tmp_1;
  if (tmp5_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp5_safe_receiver.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var tmp0_safe_receiver_0 = element_0 instanceof StringValue() ? element_0 : null;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.z4v_1;
      var tmp_2;
      if (tmp1_safe_receiver_0 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_3 = decodeFromString(get_UrlProperties(), Companion_instance.n3k(_this__u8e3s4), tmp1_safe_receiver_0);
        tmp_2 = tmp_3 instanceof DataClassPath() ? tmp_3 : THROW_CCE();
      }
      var tmp0_safe_receiver_1 = tmp_2;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_1);
      }
    }
    tmp_1 = destination;
  }
  var tmp6_elvis_lhs = tmp_1;
  var tmp_4;
  if (tmp6_elvis_lhs == null) {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = ensureNotNull(get_serializableProperties(_this__u8e3s4));
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_5 = defaultColumns$lambda;
    var tmp$ret$14 = new (sam$kotlin_Comparator$0())(tmp_5);
    var tmp$ret$15 = sortedWith(this_0, tmp$ret$14);
    // Inline function 'kotlin.collections.map' call
    var this_1 = take(tmp$ret$15, 5);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_1 = this_1.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var item = _iterator__ex2g4s_1.o1();
      var tmp$ret$16 = new (DataClassPathAccess())(new (DataClassPathSelf())(_this__u8e3s4), item);
      destination_0.v(tmp$ret$16);
    }
    tmp_4 = destination_0;
  } else {
    tmp_4 = tmp6_elvis_lhs;
  }
  return tmp_4;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.sdy_1 = function_0;
      }
      wi(a, b) {
        return this.sdy_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.sdy_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function defaultColumns$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_importance(a);
  var tmp$ret$1 = get_importance(b);
  return compareValues(tmp, tmp$ret$1);
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
//endregion
//region block: exports
export {
  Generator as Generator2kgtccb0jt0mi,
  Placeholder as Placeholder13jtqz2ujol8y,
  FormRenderer as FormRendererv0cfjgipxuxv,
  FormSelector as FormSelector1zdq40oqbcvms,
  FormTypeInfo as FormTypeInfo22ea2b5qphu87,
  get_annotation as get_annotation27eynvnd00ffx,
  get_basePriority as get_basePriority3aha966bwjyn2,
  get_handlesField as get_handlesField2upaii4zzjnxm,
  get_kind as get_kind27kjvyfnc9an8,
  matches as matches2uu672wulv59r,
  get_nullable as get_nullable1f61etx34dvfo,
  priority as priority7vn90mx06311,
  size as size1hf9cj08wgoyn,
  get_type as get_type3f1sl153qhh1c,
  Generator_0 as Generator1qrulkrel7e5m,
  Placeholder_0 as Placeholder31b9p3m3d8sxy,
  ViewRenderer as ViewRenderer1i6kznnbg7y21,
  defaultColumns as defaultColumns2bko8gwvd6xmb,
  form as form1pdmcqj387954,
  Companion_instance_0 as Companion_instancegwok6qx7et5m,
  Companion_instance_1 as Companion_instance17v8p6g2424o4,
};
//endregion

//# sourceMappingURL=FormRenderer.mjs.map
